import { FC } from 'react'
import { useWeb3Provider } from '@g4g/wallet-modal/components/Web3ContextProvider'
import CheckoutPaymentConnected from './connected/CheckoutPaymentConnected'
import { useShoppingCart } from '../../shopping-cart/ShoppingCartProvider'
import { useUpdateEffect, usePreviousDistinct } from 'react-use'
import { useCheckoutOpsDispatch } from '../CheckoutProvider'
import ConnectWalletKorag from '../../shared/wallet/ConnectWalletKorag'
import ErrorKorag from '../../shared/wallet/ErrorKorag'

const CheckoutPaymentCard: FC = () => {
  const { account, loadingAccount, error, chainId } = useWeb3Provider()
  const dispatch = useCheckoutOpsDispatch()
  const items = useShoppingCart()
  const previousAccount = usePreviousDistinct(account)

  useUpdateEffect(() => {
    // Reset the checkout state if
    // accounts are being switched around
    if (previousAccount && account !== previousAccount) {
      dispatch({ type: 'reset' })
    }
  }, [account, previousAccount, dispatch])

  return (
    <>
      <div className="flex flex-col items-center w-full rounded-lg">
        {error ? (
          <ErrorKorag />
        ) : (
          <>
            {!loadingAccount && items.length > 0 && (
              <>
                {account && chainId ? (
                  <CheckoutPaymentConnected account={account} chainId={chainId} />
                ) : (
                  <ConnectWalletKorag>
                    Connect a Wallet to complete your purchase
                  </ConnectWalletKorag>
                )}
              </>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default CheckoutPaymentCard
